import { useContext } from 'react';
import { VersionContext } from '../contexts/VersionContext';

const useVersion = () => useContext(VersionContext);

export default useVersion;
